import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Button, Row, Col } from 'antd';
import { EditorState } from './editorEnum';

interface ResourceCreateCommandRowProps {
  postRedirectURL: string;
  cancelRedirectURL: string;
  handleSubmit: (cardState?: EditorState) => void;
  redirectSubmit: boolean;
  submittingForm: boolean;
  editorState: EditorState;
  disableCreateButton?: boolean;
}

const ResourceCreateCommandRow: React.FC<ResourceCreateCommandRowProps> = ({
  postRedirectURL,
  cancelRedirectURL,
  handleSubmit,
  redirectSubmit,
  submittingForm,
  editorState,
  disableCreateButton = false
}): JSX.Element => {
  return (
    <>
      {redirectSubmit ? (
        <Redirect to={postRedirectURL} />
      ) : (
        <Row style={{ marginTop: '24px' }} gutter={16}>
          <Col>
            {editorState === EditorState.NEW ? (
              <Button
                disabled={disableCreateButton}
                key="1"
                data-cy="Create"
                type="primary"
                onClick={(): void => {
                  handleSubmit();
                }}
                loading={submittingForm}
              >
                Create
              </Button>
            ) : (
              <Button
                key="1"
                data-cy="Edit"
                type="primary"
                onClick={(): void => {
                  handleSubmit();
                }}
                loading={submittingForm}
              >
                Save
              </Button>
            )}
          </Col>
          <Col>
            <Link to={cancelRedirectURL}>
              <Button key="2" data-cy="Cancel" type="primary" ghost>
                Cancel
              </Button>
            </Link>
          </Col>
        </Row>
      )}
    </>
  );
};
export default ResourceCreateCommandRow;
